import { jsxs as r, jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m34.398 41.609-3.917 1.05 1.05 3.916 3.917-1.05-1.05-3.916Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m36.91 9.46-1.895-1.02-1.897 1.02-19.005 10.234-.098.052L-.03 12.184v4.543l12.04 6.483v27.782H-.03v4H28.472V35.302h13.085V54.992h13.464l-1.072-4h-8.392v-19.69l-21.085-.001v19.69H16.02V23.21l18.994-10.228L54.02 23.215V50.93l4-1.072V20.826l-2.103-1.132L36.91 9.46Z"
        }
      )
    ]
  }
);
export {
  e as SemiDetached
};
